class BigDropDeliveryTracker {
  constructor(element) {
    this.element = element;
    this.threshold = Number(element.dataset.threshold);
    this.cartTotal = Number(element.dataset.cartTotal) || 0;
    this.currency = element.dataset.currency || 'GBP';
    this.progressBar = element.querySelector('.bigdrop-delivery-tracker__bar');
    this.progress = element.querySelector('[data-bigdrop-delivery-progress]');
    this.text = element.querySelector('[data-bigdrop-delivery-text]');
    this.quantityInput = element
      .closest('.product-single__box')
      ?.querySelector('.product-single__box__block--quantity_selector input[name="quantity"]');
    this.quantityControl = this.quantityInput?.closest('quantity-input');
    const variantDataElement = element.querySelector('[data-bigdrop-delivery-variants]');

    if (!this.threshold || !variantDataElement) return;

    try {
      this.variantPrices = JSON.parse(variantDataElement.textContent);
    } catch (error) {
      console.warn('Big Drop delivery tracker: unable to parse variant data.', error);
      return;
    }

    this.currentVariantId = element.dataset.selectedVariantId;
    if (!this.currentVariantId || !this.variantPrices[this.currentVariantId]) {
      this.currentVariantId = Object.keys(this.variantPrices)[0];
    }

    this.onVariantChange = this.onVariantChange.bind(this);
    this.render = this.render.bind(this);
    document.addEventListener('variant:changed', this.onVariantChange);
    this.quantityControl?.addEventListener('update', this.render);
    this.quantityInput?.addEventListener('input', this.render);
    this.quantityInput?.addEventListener('change', this.render);
    this.render();
  }

  onVariantChange(event) {
    const variantId = event.detail?.variant?.id;
    if (!variantId) return;

    if (
      event.detail.sectionId &&
      this.element.dataset.sectionId &&
      event.detail.sectionId !== this.element.dataset.sectionId
    ) {
      return;
    }

    this.currentVariantId = String(variantId);
    this.render();
  }

  render() {
    const variantPrice = Number(this.variantPrices[this.currentVariantId]) || 0;
    const quantity = Math.max(1, Number.parseInt(this.quantityInput?.value, 10) || 1);
    const projectedTotal = this.cartTotal + variantPrice * quantity;
    const remaining = Math.max(0, this.threshold - projectedTotal);
    const percent = Math.min(100, (projectedTotal / this.threshold) * 100);

    this.progress.style.width = `${percent}%`;
    this.progressBar.setAttribute('aria-valuenow', String(Math.round(percent)));
    this.text.textContent = remaining === 0
      ? 'You’ve unlocked free delivery'
      : `${this.formatMoney(remaining)} to free delivery`;
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency',
      currency: this.currency,
      maximumFractionDigits: cents % 100 === 0 ? 0 : 2,
    }).format(cents / 100);
  }
}

document.querySelectorAll('[data-bigdrop-delivery-tracker]').forEach((element) => {
  new BigDropDeliveryTracker(element);
});
